/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_LeaveInputs */

const th_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ออกจากการประชุม`)
};

const en_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave the meeting`)
};

const ja_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミーティングから退出`)
};

const zh_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离开会议`)
};

const es_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salir de la reunión`)
};

const pt_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair da reunião`)
};

const id_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan pertemuan`)
};

const fr_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter la réunion`)
};

const tl_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umalis sa miting`)
};

const vi_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rời cuộc họp`)
};

const ko_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회의 나가기`)
};

const de_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting verlassen`)
};

const ru_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти из встречи`)
};

const tr_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplantıdan ayrıl`)
};

const it_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci dalla riunione`)
};

const pl_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opuść spotkanie`)
};

const uk_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вийти зі зустрічі`)
};

const hi_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैठक छोड़ें`)
};

const ar_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مغادرة الاجتماع`)
};

const ms_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan mesyuarat`)
};

const bn_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সভা ছাড়ুন`)
};

const zh_tw2_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`離開會議`)
};

const zh_hk2_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`離開會議`)
};

const ur_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاقات چھوڑیں`)
};

const fa_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترک جلسه`)
};

const sw_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toka kwenye mkutano`)
};

const nl_meeting_leave = /** @type {(inputs: Meeting_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprek verlaten`)
};

/**
* | output |
* | --- |
* | "Leave the meeting" |
*
* @param {Meeting_LeaveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_leave = /** @type {((inputs?: Meeting_LeaveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_LeaveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_leave(inputs)
	if (locale === "ja") return ja_meeting_leave(inputs)
	if (locale === "zh") return zh_meeting_leave(inputs)
	if (locale === "es") return es_meeting_leave(inputs)
	if (locale === "pt") return pt_meeting_leave(inputs)
	if (locale === "id") return id_meeting_leave(inputs)
	if (locale === "fr") return fr_meeting_leave(inputs)
	if (locale === "tl") return tl_meeting_leave(inputs)
	if (locale === "vi") return vi_meeting_leave(inputs)
	if (locale === "ko") return ko_meeting_leave(inputs)
	if (locale === "de") return de_meeting_leave(inputs)
	if (locale === "ru") return ru_meeting_leave(inputs)
	if (locale === "tr") return tr_meeting_leave(inputs)
	if (locale === "it") return it_meeting_leave(inputs)
	if (locale === "pl") return pl_meeting_leave(inputs)
	if (locale === "uk") return uk_meeting_leave(inputs)
	if (locale === "hi") return hi_meeting_leave(inputs)
	if (locale === "ar") return ar_meeting_leave(inputs)
	if (locale === "ms") return ms_meeting_leave(inputs)
	if (locale === "bn") return bn_meeting_leave(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_leave(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_leave(inputs)
	if (locale === "ur") return ur_meeting_leave(inputs)
	if (locale === "fa") return fa_meeting_leave(inputs)
	if (locale === "sw") return sw_meeting_leave(inputs)
	if (locale === "nl") return nl_meeting_leave(inputs)
	return en_meeting_leave(inputs)
});